import { render } from "./DashboardCreateBusiness.vue?vue&type=template&id=12558f62&scoped=true"
import script from "./DashboardCreateBusiness.vue?vue&type=script&lang=js"
export * from "./DashboardCreateBusiness.vue?vue&type=script&lang=js"

import "./DashboardCreateBusiness.vue?vue&type=style&index=0&id=12558f62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12558f62"]])

export default __exports__